import { Injectable } from '@angular/core';
import { SortingParams } from 'src/app/interfaces/connections.interface';
import {
  CommentPosition,
  CommentView,
  FullRootCommentView,
  LoadedCommentsState,
} from 'src/app/interfaces/posts.interface';
import { CommentSortingStrategyService } from './comment-sorting-strategy.service';

@Injectable({ providedIn: 'root' })
export class AscendingCommentSortingStrategyService extends CommentSortingStrategyService {
  public getSortingParams(): SortingParams {
    return SortingParams.CreatedAsc;
  }

  public addNewRootComment(
    loadedComments: LoadedCommentsState,
    newRootComment: FullRootCommentView,
  ): LoadedCommentsState {
    const newLoadedCommentsState: LoadedCommentsState = structuredClone(loadedComments);

    newLoadedCommentsState.rootCommentFullViews = this.sortRootComments([
      ...newLoadedCommentsState.rootCommentFullViews,
      newRootComment,
    ]);

    newLoadedCommentsState.totalRootCommentsCount++;
    // this wasn't incremented before, but maybe it makes sense to do it
    newLoadedCommentsState.loadedRootCommentsCount++;

    return newLoadedCommentsState;
  }

  public addNewReply(
    loadedComments: LoadedCommentsState,
    repliedCommentPosition: CommentPosition,
    replyCommentView: CommentView,
  ): LoadedCommentsState {
    const newLoadedCommentsState: LoadedCommentsState = structuredClone(loadedComments);

    const parentCommentView: FullRootCommentView =
      newLoadedCommentsState.rootCommentFullViews[repliedCommentPosition.indexRoot];

    parentCommentView.replyCommentViews = [...parentCommentView.replyCommentViews, replyCommentView];
    parentCommentView.replyCommentViews = this.sortReplies(parentCommentView.replyCommentViews);

    // todo: this wasn't done before but maybe it should
    parentCommentView.loadedReplyCommentsCount++;
    parentCommentView.totalReplyCommentsCount++;

    return newLoadedCommentsState;
  }

  protected sortingByDate(a: CommentView, b: CommentView): number {
    return new Date(a.source.creation_date).getTime() - new Date(b.source.creation_date).getTime();
  }
}
